module.exports = __webpack_public_path__ + "img/mbs-icon.412dd234.png";